<template>
  <vs-popup
    classContent="popup-example"
    title="HTML Editor"
    :active.sync="show"
  >
    <div>
      <vs-textarea v-model="data" rows="10"></vs-textarea>
    </div>
    <div class="text-right">
      <vs-button @click="submit()">Save</vs-button>
    </div>
  </vs-popup>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";

export default {
  components: {},
  props: {
    showDialog: false,
    data: null
  },
  data: () => ({}),
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  watch: {},
  created() {},
  methods: {
    submit() {
      this.$emit("submit", this.data);
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.hidden_header {
  display: none;
}
</style>
